import React from 'react';

function useSidebar() {
  const [show, setShow] = React.useState(false);

  const onShow = () => setShow(false);
  const onHide = () => setShow(true);
  const onReverseShow = () => setShow(!show);

  /* will helping on re-rendering current main url into sidebar */
  const [currentPath, setCurrentPath] = React.useState(window.location.pathname.split('/')[1]);

  return {
    show, onShow, onHide, onReverseShow, currentPath, setCurrentPath,
  };
}

export default useSidebar;
